import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class BusinessCalendarService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getHours() {
        try {
            const r = await withRetry(() => this.api.getHours(), { maxRetries: 2 });
            return { success: true, data: r.data, message: r.message };
        } catch (e) {
            throw this._handle(e, 'Failed to load business hours');
        }
    }

    async upsertHours(body) {
        try {
            const r = await this.api.upsertHours(body);
            return { success: true, data: r.data, message: r.message || 'Çalışma saatleri kaydedildi' };
        } catch (e) {
            throw this._handle(e, 'Failed to save business hours');
        }
    }

    async listHolidays() {
        try {
            const r = await withRetry(() => this.api.listHolidays(), { maxRetries: 2 });
            return { success: true, data: r.data || [], message: r.message };
        } catch (e) {
            throw this._handle(e, 'Failed to list holidays');
        }
    }

    async createHoliday(body) {
        try {
            const r = await this.api.createHoliday(body);
            return { success: true, data: r.data, message: r.message || 'Tatil eklendi' };
        } catch (e) {
            throw this._handle(e, 'Failed to create holiday');
        }
    }

    async previewDeadline(body) {
        try {
            const r = await this.api.previewDeadline(body);
            return { success: true, data: r.data, message: r.message };
        } catch (e) {
            throw this._handle(e, 'Failed to preview SLA deadline');
        }
    }

    async deleteHoliday(id) {
        try {
            const r = await this.api.deleteHoliday(id);
            return { success: true, data: r.data, message: r.message || 'Tatil silindi' };
        } catch (e) {
            throw this._handle(e, 'Failed to delete holiday');
        }
    }

    _handle(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
